export default __webpack_public_path__ + "static/media/inventory-set-group-icon-green.49459126.svg";